import { publicEnv } from '../config/env';
import { buildApiUrl } from './apiUrl';

const fallback: RTCIceServer[] = [{ urls: 'stun:stun.l.google.com:19302' }];
let cached: Promise<RTCIceServer[]> | undefined;

export function buildWebRtcConfigUrl(apiBaseUrl: string): string {
  return buildApiUrl(apiBaseUrl, '/config/webrtc');
}

export function getIceServers(): Promise<RTCIceServer[]> {
  cached ??= fetch(buildWebRtcConfigUrl(publicEnv.apiBaseUrl))
    .then(async (response) => {
      if (!response.ok) throw new Error('ICE configuration unavailable');
      const body = await response.json() as { iceServers?: RTCIceServer[] };
      return body.iceServers?.length ? body.iceServers : fallback;
    })
    .catch(() => fallback);
  return cached;
}
